import { css } from '@emotion/react';

export const CiutadellaFont = css`
  @font-face {
    font-family: 'Ciutadella';
    font-weight: 400;
    font-display: swap;
    src: url('https://d1ngac5455aayn.cloudfront.net/fonts/Ciutadella/ciutadella_W04_Medium.woff2')
      format('woff2');
  }
`;
